export const DEMO_WHATSAPP_NUMBER = "522382730259"

export const DEMO_WHATSAPP_MESSAGE =
  "Hola, quiero una demo para mi clínica dental."

export const DEMO_WHATSAPP_URL = `https://wa.me/${DEMO_WHATSAPP_NUMBER}?text=${encodeURIComponent(DEMO_WHATSAPP_MESSAGE)}`
